import { useCallback } from "react";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import {
  EsignReminderPerPolicy,
  EsignReminderStatus,
} from "@covertree/agent-portal-graphql";
import {
  NOT_ALLOWED_FOR_ESIGN_MSG,
  NOT_ELIGIBLE_FOR_ESIGN_MSG,
  ONLY_ONE_ESIGN_REMINDER_MSG,
} from "@consts/index";
import { Button } from "@covertree/ui";
import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { Modal } from "@covertree/ui";

interface Props {
  open: boolean;
  onClose: () => void;
  statuses: EsignReminderPerPolicy[];
}
export function BulkEsignRemindersStatusesModal({
  open,
  onClose,
  statuses,
}: Props) {
  const getEsignReminderStatusMsg = useCallback(
    (result: Partial<EsignReminderPerPolicy>) => {
      if (result.esignReminderStatus === EsignReminderStatus.Failed) {
        if (result.message?.toLowerCase().includes(ONLY_ONE_ESIGN_REMINDER_MSG))
          return "Cannot send more than one esign reminder per hour. Please try again later.";

        if (result.message?.toLowerCase().includes(NOT_ELIGIBLE_FOR_ESIGN_MSG))
          return "Policy requires physical mail to be sent";

        if (result.message?.toLowerCase().includes(NOT_ALLOWED_FOR_ESIGN_MSG))
          return "You are not allowed to send e-sign reminder for this policy";

        return "Unable to send esign reminder. Please try again or contact us.";
      }
      return "Esign reminder was sent successfully!";
    },
    []
  );

  return (
    <Modal open={open} onClose={onClose} maxWidth="sm" title="E-sign Reminders">
      {!statuses?.length ? (
        <Typography>
          No{" "}
          <Typography component="span" color="secondary">
            e-sign reminders
          </Typography>{" "}
          have been sent.
        </Typography>
      ) : (
        <>
          <Typography gutterBottom mb={2}>
            Due to the email address change, following{" "}
            <Typography component="span" color="secondary">
              e-sign reminders
            </Typography>{" "}
            have been sent
          </Typography>
          <Grid container spacing={2}>
            {statuses.map((status) => (
              <Grid item xs={12} key={`esign-reminder-${status.policyLocator}`}>
                <DisplayPropertiesCard
                  properties={[
                    {
                      label: "Policy Locator",
                      value: status.policyLocator!,
                      gridSize: 6,
                    },
                    {
                      label: "E-sign Reminder Status",
                      value: getEsignReminderStatusMsg(status),
                      gridSize: 6,
                    },
                  ]}
                />
              </Grid>
            ))}
            <Grid item xs={12} container justifyContent="flex-end">
              <Button onClick={onClose} sx={{ alignSelf: "flex-end" }}>
                Close
              </Button>
            </Grid>
          </Grid>
        </>
      )}
    </Modal>
  );
}
